'use client'

import type { Address } from 'viem'

import { Button } from '@repo/ui'

interface ActionsCellProps {
  account: Address | undefined
  onLiquidate: () => void
}

/**
 * Deliberately not gated on the query's fetching state. Rows only exist once data has loaded, so a
 * fetching flag could only ever fire during a *background* refetch — and the shared `QueryClient`
 * refetches on window focus, so gating on it would disable every Liquidate button each time the
 * liquidator returns to the tab, swallowing the click that brought them back.
 */
export function ActionsCell({ account, onLiquidate }: ActionsCellProps) {
  return (
    <Button data-testid="position-liquidate" disabled={!account} onClick={onLiquidate} size="sm">
      Liquidate
    </Button>
  )
}
